import { Component, Input, input } from "@angular/core";

@Component({
  selector: "app-pasaport-modal",
  templateUrl: "./pasaport-modal.component.html",
  standalone: true,
})
export class PasaportModalComponent {
  constructor() {}
  // emit classname
  @Input() className: string = "";
  // Method to close the modal
  // closeModal() {
  //   const modal = document.querySelector(".modal") as HTMLElement;
  //   if (modal) {
  //     modal.style.display = "none";
  //   }
  // }

  // // Method to open the modal
  // openModal() {
  //   const modal = document.querySelector(".modal") as HTMLElement;
  //   if (modal) {
  //     modal.style.display = "block";
  //   }
  // }
}
